// :: User Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// :: State
const state = {
  people: {},
  peopleUpdated: new Date()
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
